import React from 'react';

// Import images
import overviewPopup from "../assets/img/Products/Overview-Popup.png";
import popupCustomization from "../assets/img/Products/Popup-Customization.png";
import selectPopup from "../assets/img/Products/Select-Popup.png";
import userCollaborationPopups from "../assets/img/Products/User-collaboration-Popups.png";
import dragDrop from "../assets/img/Products/Drag-Drop.png";
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { Link } from 'react-router-dom';

const PopupProduct = () => {
  return (
    <div>
        <Header/>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div className="container text-center py-5" style={{ maxWidth: '900px' }}>
          <h4 className="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Products</h4>
          <ol className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
            <li className="breadcrumb-item"><Link to={"/"}>Home</Link></li>
            <li className="breadcrumb-item"><a href="#">Products</a></li>
            <li className="breadcrumb-item active text-primary">Popup Shopify</li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* B2B Feature Start */}
      <section className="bg-yellow">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6">
              <div className="user-selection">
                <div className="rounded bg-light">
                  <img
                    src={overviewPopup}
                    className="img-fluid rounded w-100"
                    alt="Overview of Popup"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 p-5">
              <h1>Overview of Shopify Popup Apps</h1>
              <p className="font-size-p">
                Shopify popup apps help boost engagement and conversions by displaying product promotions, discounts, cart
                reminders, and signups at key moments. These apps offer customization, automation, and analytics to
                optimize user interactions and sales.
              </p>
              <h5>Key Popup Metrics: Impressions, Interactions & Conversions</h5>
              <ul>
                <li>
                  <span className="icon-box"></span>Impressions – The number of times a popup is displayed to visitors.
                </li>
                <li>
                  <span className="icon-box"></span>Interactions – How often users engage with the popup (clicks, form
                  submissions, etc.).
                </li>
                <li>
                  <span className="icon-box"></span>Conversion Rate – The percentage of users who complete an action
                  (purchase, signup, etc.).
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}

      {/* B2B Feature Start */}
      <section className="bg-white">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 p-5">
              <h1>Seamless Collaboration & Secure Verification</h1>
              <p className="font-size-p">Invite Team Members with Ease</p>
              <ul>
                <li>
                  <span className="icon-box"></span>Add members by email and assign roles instantly.
                </li>
                <li>
                  <span className="icon-box"></span> Generate & share project access links securely.
                </li>
                <li>
                  <span className="icon-box"></span> Collaborate effortlessly with your team.
                </li>
              </ul>
            </div>
            <div className="col-md-6 col-lg-6">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src={popupCustomization}
                    className="img-fluid rounded w-45"
                    alt="About-epic-X Process"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}

      {/* B2B Feature Start */}
      <section className="bg-yellow">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6">
              <div className="user-selection">
                <div className="rounded bg-light">
                  <img
                    src={selectPopup}
                    className="img-fluid rounded w-100"
                    alt="Select-Popup template"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 p-5">
              <h1>Ready-to-Use Popup Templates</h1>
              <p className="font-size-p">
                Choose from a wide range of professionally designed popup templates to match your brand and marketing
                goals. With EPIC-X, you can:
              </p>
              <ul>
                <li>
                  <span className="icon-box"></span> Select by Type – Lightbox, sidebar, floating bar, fullscreen, and
                  more.
                </li>
                <li>
                  <span className="icon-box"></span> Customize Effortlessly – Edit text, images, colors, and styles to
                  fit your brand.
                </li>
                <li>
                  <span className="icon-box"></span>Boost Engagement – Use high-converting popups to capture leads and
                  drive sales.
                </li>
                <li>
                  <span className="icon-box"></span>Launch Instantly – No coding required, just select, customize, and go
                  live!
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}

      {/* B2B Feature Start */}
      <section className="bg-white">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 p-5">
              <h1>Enhancing User Collaboration with Popups</h1>
              <p className="font-size-p">
                Popups can serve as an effective tool for fostering user collaboration by enabling real-time engagement
                and interaction.
              </p>
              <p className="font-size-p">
                For example, businesses can use popups to collect customer feedback, provide live chat support, or offer
                group purchasing deals. Interactive popups that allow users to share products with friends, vote on
                upcoming designs, or participate in surveys create a more engaging shopping environment.
              </p>
            </div>
            <div className="col-md-6 col-lg-6">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src={userCollaborationPopups}
                    className="img-fluid rounded w-45"
                    alt="About-epic-X Process"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}

      {/* B2B Feature Start */}
      <section className="bg-yellow">
        <div className="container">
          <div className="row g-5">
            <div className="col-md-6 col-lg-6 p-5">
              <h1>EPIC-X: Effortless Shopify Popup Customization</h1>
              <p className="font-size-p">
                Unlock the power of seamless customization with EPIC-X's Drag and Drop Builder! Designed to simplify your
                Shopify experience, our intuitive editor lets you:
              </p>
              <ul>
                <li>
                  <span className="icon-box"></span>Drag & Drop Elements – Effortlessly add text, images, videos,
                  buttons, icons, and more.
                </li>
                <li>
                  <span className="icon-box"></span>Real-Time Editing – Modify popups directly on-screen for instant
                  updates.
                </li>
                <li>
                  <span className="icon-box"></span> Flexible Customization – Choose from multiple fonts, colors, and
                  layout options.
                </li>
                <li>
                  <span className="icon-box"></span> Engage & Convert – Create high-impact popups that boost customer
                  interactions and sales.
                </li>
              </ul>
            </div>
            <div className="col-md-6 col-lg-6 p-5">
              <div className="user-selection">
                <div className="rounded">
                  <img
                    src={dragDrop}
                    className="img-fluid rounded"
                    alt="Drag and Drop"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* B2B Feature End */}
      <Footer/>
    </div>
  );
};

export default PopupProduct;